import React from 'react'
import PropTypes from 'prop-types'
import { H4 } from 'styled'

const Heading4 = ({ children, richText }) => {
  return (
    <React.Fragment>
      <H4
        fontSize="18px"
        fontWeight="500"
        richText={richText}
      >
        {children}
      </H4>
    </React.Fragment>
  )
}

export default Heading4

Heading4.propTypes = {
  children: PropTypes.array,
  richText: PropTypes.bool
}
